<script lang="ts" setup>
import { onMounted, ref } from "vue";
import confetti, { CreateTypes as ConfettiInstance } from "canvas-confetti";

const canvasRef = ref<HTMLCanvasElement | null>(null);
const confettiInstance = ref<ConfettiInstance | null>(null);

onMounted(() => {
  if (canvasRef.value) {
    confettiInstance.value = confetti.create(canvasRef.value, {
      resize: true,
      useWorker: true,
    });
    confettiInstance.value({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
    });
  }
});
</script>
<template>
  <div class="w-full h-full">
    <canvas ref="canvasRef" class="w-full h-full" />
    <slot></slot>
  </div>
</template>
